import React, { useState } from 'react';
import headerGraphic from '../../assets/images/backgrounds/header-graphic.webp';
import arrow from '../../assets/arrow.svg';
import arrowCorner from '../../assets/arrow-corner.svg';
import Button from '../../components/Button';
// import { Link } from 'react-router-dom';

const SKILL_SNIPPET = `install the wayfinder openclaw skill by git cloning https://github.com/WayfinderFoundation/wayfinder-openclaw-skill to our skills directory, read the skill.md and take me through the setup process.`;

export default function HeroSection() {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(SKILL_SNIPPET);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section
      className='relative min-h-screen flex flex-col items-center justify-center 3xl:bg-contain bg-top bg-no-repeat bg-auto px-6'
      style={{
        backgroundImage: `url(${headerGraphic})`,
      }}
    >
      <div className='text-center py-48'>
        <h1
          className='text-center font-semibold text-transparent bg-clip-text mb-4 text-5xl sm:text-6.5xl leading-none min-h-[4.12rem]'
          style={{
            textShadow: '0 4px 24px rgba(0, 0, 0, 0.25)',
            letterSpacing: '-1.92px',
            background: 'linear-gradient(180deg, #FFF 50.5%, #879898 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          Intelligent agents on every chain
        </h1>

        <p className='text-white/60 mb-10 text-lg md:text-base'>
          Empowering seamless blockchain mastery with AI agents on every chain.
        </p>

        <div className='flex justify-center gap-6'>
          <Button size='md' color='mint' href='https://app.wayfinder.ai'>
            Launch App
          </Button>
          {/* <Button size='md' color='gray'>
            <Link to='/faq'>Learn More</Link>
          </Button> */}
        </div>

        <div className='mt-10 max-w-2xl mx-auto'>
          <p className='text-white/60 text-sm mb-3'>
            Try the Wayfinder skill on your OpenClaw instance today — just paste this to your bot
          </p>
          <div className='relative group'>
            <pre className='bg-white/5 border border-white/10 rounded-xl p-4 pr-14 text-left text-white/80 text-sm leading-relaxed overflow-x-auto whitespace-pre-wrap break-words'>
              <code>{SKILL_SNIPPET}</code>
            </pre>
            <button
              onClick={handleCopy}
              className='absolute top-3 right-3 p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors'
              aria-label='Copy to clipboard'
            >
              {copied ? (
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='#00A98B' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                  <polyline points='20 6 9 17 4 12' />
                </svg>
              ) : (
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='rgba(255,255,255,0.6)' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                  <rect x='9' y='9' width='13' height='13' rx='2' ry='2' />
                  <path d='M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1' />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      <div className='flex items-center justify-between mx-auto py-6 border-b border-white/8 w-full max-w-5xl gap-6'>
        <div className='flex-shrink-0'>
          <Button
            size='xs'
            color='outline'
            href='#key-features'
            className='h-8'
          >
            <img src={arrow} alt='Down arrow' width='24' height='24' />
          </Button>
        </div>
        <p className='text-white/60 text-13 max-w-md md:block hidden'>
          Wayfinder: AI-driven omnichain protocol for executing blockchain tasks
          like swaps, bridging, and deployments via natural language commands
          and intelligent shells.
        </p>
        <div className='flex gap-6 flex-shrink-0'>
          <Button color='gray' href='https://cache.wayfinder.ai/'>
            Cache Prime
            <img
              src={arrowCorner}
              alt='External link'
              width='12'
              height='12'
              className='ml-1'
            />
          </Button>
          <Button
            color='outline'
            href='https://paper.wayfinder.ai/wayfinder_paper_v1.pdf'
            target='_blank'
            rel='noreferrer'
          >
            Whitepaper
          </Button>
        </div>
      </div>
    </section>
  );
}
